import { Shield, ThumbsUp, Clock, DollarSign, Star, Users } from "lucide-react";

const features = [
  { id: "feat-1", icon: Shield, title: "Professionnalisme et fiabilité", desc: "Un service sérieux sur lequel vous pouvez compter, à chaque visite." },
  { id: "feat-2", icon: ThumbsUp, title: "Qualité garantie", desc: "Nous nous assurons que le travail est bien fait, chaque fois." },
  { id: "feat-3", icon: DollarSign, title: "Soumission 100% gratuite", desc: "Obtenez une estimation sans engagement et sans frais." },
  { id: "feat-4", icon: Star, title: "Service client exceptionnel", desc: "À l'écoute de vos besoins, disponibles et faciles à joindre." },
  { id: "feat-5", icon: Clock, title: "Horaires flexibles", desc: "On s'adapte à votre emploi du temps pour vous faciliter la vie." },
  { id: "feat-6", icon: Users, title: "Jeunes professionnels motivés", desc: "Une équipe dynamique et passionnée par le travail bien fait." },
];

export const WhyChooseUs = () => (
  <section id="pourquoi" className="bg-white py-16 md:py-24" data-testid="why-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-12">
        <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4" data-testid="why-title">Pourquoi nous choisir</h2>
        <p className="text-base lg:text-lg text-gray-600 max-w-2xl mx-auto">
          Un service d'entretien extérieur sur lequel vous pouvez vraiment compter.
        </p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {features.map((f) => {
          const Icon = f.icon;
          return (
            <div key={f.id} className="bg-[#F5F5F0] rounded-lg p-6 text-center" data-testid={`feature-card-${f.id}`}>
              <div className="w-12 h-12 rounded-full bg-green-50 border border-green-100 flex items-center justify-center mx-auto mb-4">
                <Icon className="w-6 h-6 text-[#2D5A3D]" />
              </div>
              <h3 className="font-semibold text-gray-900 mb-2">{f.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{f.desc}</p>
            </div>
          );
        })}
      </div>
    </div>
  </section>
);
